import { gameState } from "appworks/model/game-state";
import { RequestPayload } from "appworks/model/gameplay/requests/request-payload";
import { Services } from "appworks/services/services";
import { ForceSpinType, getForcePayload } from "gamevy/commands/comms/force-command";
import { gamevyForceData } from "gamevy/components/gamevy-force-data";
import {
    ForceCascadeRequestPayload,
    ForceCloseRequestPayload,
    ForceFreeSpinRequestPayload,
    ForceRequestPayload,
    ForceRespinRequestPayload
} from "gamevy/integration/builders/requests/force-request-payload";
import { IntegrationDebugger } from "slotworks/debug/integration-debugger/integration-debugger";
import { CascadeRequestPayload } from "slotworks/model/gameplay/requests/cascade-request-payload";
import { FreespinRequestPayload } from "slotworks/model/gameplay/requests/freespin-request-payload";
import { RespinRequestPayload } from "slotworks/model/gameplay/requests/respin-request-payload";
import { SpinRequestPayload } from "slotworks/model/gameplay/requests/spin-request-payload";

export class GamevyIntegrationDebugger extends IntegrationDebugger {
    protected sendRequest(payload: RequestPayload, clear: boolean = true) {
        const data = gamevyForceData.getForceData();

        let type: ForceSpinType;
        if (payload instanceof CascadeRequestPayload) {
            type = ForceSpinType.CASCADE;
        } else if (payload instanceof FreespinRequestPayload) {
            type = ForceSpinType.FREESPIN;
        } else if (payload instanceof RespinRequestPayload) {
            type = ForceSpinType.RESPIN;
        } else if (payload instanceof SpinRequestPayload) {
            type = ForceSpinType.SPIN;
        }

        if (data && type !== undefined) {
            payload = getForcePayload(type, data);
        }

        if ((payload instanceof FreespinRequestPayload || payload instanceof ForceFreeSpinRequestPayload) && gameState.getCurrentGame().getRootRecord().getFreespinsWon() > 0) {
            payload = new ForceCloseRequestPayload();
        }

        if (
            payload instanceof ForceRequestPayload ||
            payload instanceof ForceFreeSpinRequestPayload ||
            payload instanceof ForceCascadeRequestPayload ||
            payload instanceof ForceRespinRequestPayload
        ) {
            if (payload instanceof ForceRequestPayload) {
                payload.creditPerLine = Services.bet.getCreditPerLine();
                payload.creditSize = Services.bet.getCreditSize();
            }

            payload.data = data;
        }

        gamevyForceData.clearForceData();

        return super.sendRequest(payload, clear);
    }
}
